module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/BirthdayGirl-503af057f71c03f19edbc1be34410ce0.png";